function initializeRouteProtection() {
  const routeProtectionForm = document.querySelector(
    ".route-pack-protection_container .route-pack-protection_form"
  );
  const routeProtectionSwitch = document.getElementById(
    "route-pack-protection_switch"
  );
  const routeProtectionATC = document.getElementById("route-pack-protection_id");

  if (!routeProtectionForm || !routeProtectionSwitch || !routeProtectionATC) return;

  function updateSwitchStatus(status) {
    routeProtectionSwitch.disabled = status;
  }

  function handleCartAction(id, qty) {
    const url =
      qty > 0
        ? window.Shopify.routes.root + "cart/add.js"
        : window.Shopify.routes.root + "cart/change.js";
    const body = JSON.stringify(
      qty > 0 ? { items: [{ id: id, quantity: qty }] } : { id: id, quantity: 0 }
    );

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        document.dispatchEvent(new CustomEvent('pack-protection', { detail: data }));
        updateSwitchStatus(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        updateSwitchStatus(false);
      });
  }

  function updateProtectionItem() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((cart) => {
        const routeProtectionItem = cart.items.find(item => item.id === parseInt(routeProtectionATC.value));

        if (routeProtectionItem && cart.item_count == 1) {
          handleCartAction(routeProtectionATC.value, 0);
          routeProtectionSwitch.checked = false;
        } else if (cart.item_count > 0) {
          routeProtectionSwitch.checked = true;
          handleCartAction(routeProtectionATC.value, 1);
        } else {
          routeProtectionSwitch.checked = false;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  if (!localStorage.getItem("routeProtectionAdded")) {
    localStorage.setItem("routeProtectionAdded", "true");
    updateProtectionItem();
  }

  routeProtectionForm.addEventListener("change", function (event) {
    if (event.target.id === "route-pack-protection_switch") {
      const routeProtectionATC = event.target
        .closest(".route-pack-protection_form")
        .querySelector("#route-pack-protection_id");

      if (routeProtectionATC) {
        const id = routeProtectionATC.value;
        const qty = event.target.checked ? 1 : 0;

        updateSwitchStatus(true);
        handleCartAction(id, qty);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeRouteProtection();
});

document.addEventListener("cart-update", function (event) {
  initializeRouteProtection();
});